import React, { Component } from 'react';
import Header from './../common/Header';
import Loader from './../common/Loader';
import { Card, Button } from 'reactstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import moment from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import { fetchLeaderBoard, fetchImages } from '../../actions/LeaderBoard/LeaderBoardAction';
import '../../index.css';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import url from '../../components/common/BaseURL';

const baseURL = url.baseURL;

function getCaret(direction) {
    if (direction === 'asc') {
        return (
            <i className="fa fa-sort-amount-asc" aria-hidden="true" style={{ color: '#808080', paddingLeft: 10 }} />
        );
    }
    if (direction === 'desc') {
        return (
            <i className="fa fa-sort-amount-desc" aria-hidden="true" style={{ color: '#808080', paddingLeft: 10 }} />
        );
    }
    return (
        <i className="fa fa-arrows-v" aria-hidden="true" style={{ color: '#808080', paddingLeft: 10 }} />
    );
}

class Campaign extends Component {

    constructor(props) {
        super(props);

        this.handleApply = this.handleApply.bind(this);

        this.state = {
            loading: true,
            startDate: moment().startOf('isoweek'),
            endDate: moment().endOf('week'),
            ranges: {
                'This Week': [moment().startOf('isoweek'), moment().endOf('week')],
                'Last Week': [moment().subtract(1, 'week').startOf('isoweek'), moment().subtract(1, 'week').endOf('week')],
                'Week Before the Last': [moment().subtract(2, 'week').startOf('isoweek'), moment().subtract(2, 'week').endOf('week')]
            }
        };

        this.options = {
            defaultSortName: 'name',  
            defaultSortOrder: 'desc'
        };
    }

    componentWillMount() {
        const { users } = this.props;
        const start = this.state.startDate.format('YYYY-MM-DD').toString();
        const end = this.state.endDate.format('YYYY-MM-DD').toString();
        this.props.fetchLeaderBoard(users, start, end);
        this.props.fetchImages(users, start, end);
    }

    componentDidMount() {
        setTimeout(() => this.setState({ loading: false }), 500);
    }

    handleApply(event, picker) {
        this.setState({
            startDate: picker.startDate,
            endDate: picker.endDate
        });
        const { users } = this.props;
        const start = this.state.startDate.format('YYYY-MM-DD').toString();
        const end = this.state.endDate.format('YYYY-MM-DD').toString();
        this.props.fetchLeaderBoard(users, start, end);
    }

    render() {
        const { loading } = this.state;
        const start = this.state.startDate.format('DD-MM-YYYY').toString();
        const end = this.state.endDate.format('DD-MM-YYYY').toString();
        let label = start + ' to ' + end;
        if (start === end) {
            label = start;
        }
        const { leaderBoardList, users } = this.props;
        const options = {
            page: 1,
            sizePerPageList: [
                { text: '10', value: 10 },
                { text: '20', value: 20 },
                { text: 'All', value: leaderBoardList.length }
            ],
            sizePerPage: 10,
            pageStartIndex: 1,
            paginationSize: 3,
            prePage: 'Prev',
            nextPage: 'Next',
            firstPage: 'First',
            lastPage: 'Last',
            paginationPosition: 'bottom'
        };

        return (
            <div style={{ overflowX: 'hidden', overflowY: 'hidden' }}>
                <Header />
                {
                    loading === true ? <Loader /> :
                        <div className="row">
                            <div className="col-1" />
                            <div className="col-10">
                                <div className="row">
                                    <div className="col" style={{ paddingTop: 25 }}>
                                        <div className="row" style={{ paddingLeft: 20 }}>
                                            <div>
                                                <Link to="Campaign/Gallery">
                                                    <Button style={styles.galleryButtonStyle}>
                                                        Gallery
                                                    </Button>
                                                </Link>
                                            </div>
                                            <div style={{ paddingLeft: 20 }}>
                                                <a
                                                    style={{ textDecoration: 'none' }}
                                                    href={baseURL + 'campaign/activity/export?token=' + users.token + '&user_id=' + users.user_id}
                                                    target="_blank"
                                                    rel='noopener noreferrer'
                                                >
                                                    <Button style={styles.galleryButtonStyle}>
                                                        Export to CSV
                                                    </Button>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col" style={styles.rowStyle}>
                                        <Card style={{ boxShadow: `0px 5px 15px 0px rgba(0,0,0,0.05)`, borderColor: '#7ed321' }}>
                                            {/* date picker */}
                                            <DateRangePicker
                                                ranges={this.state.ranges}
                                                startDate={this.state.startDate}
                                                endDate={this.state.endDate}
                                                onApply={this.handleApply}
                                            >
                                                <div className="input-group">
                                                    <input type="text" className="form-control" value={label} readOnly style={styles.inputStyle} />
                                               <span className="input-group-btn" style={styles.spanStyle}>
                                                  <Button className="default date-range-toggle" style={styles.buttonStyle}>
                                                     <i className="fa fa-calendar" />
                                                  </Button>
                                               </span>
                                                </div>
                                            </DateRangePicker>
                                        </Card>
                                    </div>
                                </div>
                                {/* data table */}
                                <div style={{ paddingTop: 20 }}>
                                    <Card style={{ padding: 25, boxShadow: `0px 1px 15px 5px rgba(0,0,0,0.05)`, borderColor: '#7ed321' }}>
                                        <BootstrapTable data={leaderBoardList} options={options} pagination search hover multiColumnSearch>
                                            <TableHeaderColumn dataField='user_id' isKey dataSort width="110" dataAlign='center' caretRender={getCaret}>User ID</TableHeaderColumn>
                                            <TableHeaderColumn dataField='name' dataSort width="145" dataAlign='center' caretRender={getCaret}>Name</TableHeaderColumn>
                                            <TableHeaderColumn dataField='points' dataSort width="145" dataAlign='center' caretRender={getCaret}>Points</TableHeaderColumn>
                                            <TableHeaderColumn dataField='visits' dataSort width="110" dataAlign='center' caretRender={getCaret}>Visits</TableHeaderColumn>
                                            <TableHeaderColumn dataField='photos' dataSort width="145" dataAlign='center' caretRender={getCaret}>Photos</TableHeaderColumn>
                                            <TableHeaderColumn dataField='referrals' dataSort width="145" dataAlign='center' caretRender={getCaret}>Referrals</TableHeaderColumn>
                                        </BootstrapTable>
                                    </Card>
                                </div>
                                <br /><br /><br />
                            </div>
                            <div className="col-1" />
                        </div>
                }
            </div>
        );
    }
}

const styles = {
    rowStyle: {
        paddingTop: 20,
        paddingBottom: 10,
        paddingRight: 15,
        display: 'flex',
        justifyContent: 'flex-end'
    },
    inputStyle: {
        backgroundColor: '#fff',
        color: '#808080',
        fontFamily: 'Source Sans Pro-SemiBold',
        textAlign: 'center',
        boxShadow: 'none'
    },
    spanStyle: {
        backgroundColor: '#44B31F',
        borderRadius: 0,
        border: '#ced4da'
    },
    buttonStyle: {
        backgroundColor: '#44B31F',
        borderRadius: 0,
        border: '#ced4da',
        boxShadow: 'none'
    },
    galleryButtonStyle: {
        fontFamily: "Source Sans Pro-SemiBold",
        backgroundColor: '#40b508',
        borderWidth: 0,
        boxShadow: `0px 1px 15px 5px rgba(0,0,0,0.05)`
    }
};

function mapStateToProps(state) {
    return {
        users: state.login.user,
        leaderBoardList: state.leaderBoardList.leaderBoardData
    };
}

export default connect(mapStateToProps, { fetchLeaderBoard, fetchImages })(Campaign);



// WEBPACK FOOTER //
// ./src/components/Campaign/Campaign.js